<template>
  <div class="data-card">
    <h3 class="mt-0 mb-3">Исполнитель</h3>
    <el-form :model="form" :rules="rules" ref="form" class="grid-table" :class="[{ 'grid-table_border': !isEdited }]">
      <div class="grid-table__row">
        <p>Подрядчик</p>
        <div>
          <el-form-item v-if="isEdited" prop="contractorId">
            <el-select class="w-100" v-model="form.contractorId" size="medium"
                       filterable
                       @change="onChangeContractor"
                       :disabled="!$isAccess($userRoles.Admin)"
                       :loading="fetchProgressFilteredContractors">
              <el-option v-for="option in filteredContractors" :key="option.id" :label="option.name" :value="option.id"
                         :disabled="!option.workers.length" />
            </el-select>
          </el-form-item>
          <p v-else>{{ item.contractor ? item.contractor.contractorName : '' }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <div>Исполнитель</div>
        <div>
          <el-form-item v-if="isEdited" prop="workerId">
            <el-select class="w-100" :value="form.workerId" size="medium"
                       filterable
                       @change="onChangeWorker"
                       :loading="fetchProgressFilteredContractors">
              <el-option v-for="option in filteredWorkers" :key="option.id" :label="option.fullName" :value="option.id" />
            </el-select>
          </el-form-item>
          <p v-else>{{ item.worker ? item.worker.workerFullName : '' }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p>Помощник</p>
        <div>
          <el-form-item v-if="isEdited" prop="workerAssistantIds">
            <el-select class="w-100" v-model="form.workerAssistantIds"
                       filterable multiple size="medium"
                       :loading="fetchProgressFilteredContractors">
              <el-option v-for="item in filteredAssistants" :key="item.id" :label="item.fullName" :value="item.id" />
            </el-select>
          </el-form-item>
          <div class="d-flex flex-wrap" v-else>
            <span v-for="(item, ind) in item.workerAssistants" :key="ind">
              {{ item.workerFullName }}{{ind > 0 ? ', ' : ''}}
            </span>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';

const { sortBy } = require('lodash');

export default {
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    form: {
      contractorId: null,
      workerId: null,
      workerAssistantIds: [],
    },
    rules: {
      contractor: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      workerId: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // workerAssistantIds: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
  }),
  // created() {
  //   this.fillForm();
  // },
  computed: {
    ...mapGetters({
      item: 'orders/item',
      fetchProgressFilteredContractors: 'contractorsDrop/fetchProgress',
      filteredContractors: 'contractorsDrop/filteredItems',
    }),

    filteredWorkers() {
      const items = this.filteredContractors.find((item) => item.id === this.form.contractorId)?.workers || [];
      // Остаются только активные исполнители или те которые уже выбраны в заказе
      const filteredByActive = items
        .filter((worker) => (
          worker.isActive
          || worker.id === this.item.worker?.workerId
          || (this.item.workerAssistants || []).some((w) => w.workerId === worker.id)
        ));
      return sortBy(filteredByActive, [(item) => item.fullName.toLowerCase()]);
    },
    filteredAssistants() {
      return this.filteredWorkers.filter((w) => w.id !== this.form.workerId);
    },
  },
  methods: {
    ...mapActions({
      fetchFilteredContractors: 'contractorsDrop/fetchFilteredItems',
    }),
    fillForm() {
      if (this.item) {
        this.form.contractorId = this.item.contractor?.contractorId || null;
        this.form.workerId = this.item.worker?.workerId || null;
        this.form.workerAssistantIds = (this.item.workerAssistants || []).map((item) => item.workerId);
      } else {
        this.form.contractorId = null;
        this.form.workerId = null;
        this.form.workerAssistantIds = [];
      }
    },
    onChangeContractor() {
      this.form.workerId = null;
      this.form.workerAssistantIds = [];
    },
    onChangeWorker(id) {
      this.form.workerId = id;
      this.form.workerAssistantIds = this.form.workerAssistantIds.filter((aId) => aId !== id);
    },

    onSave() {
      let isValid = false;
      this.$refs.form.validate((valid) => {
        isValid = valid;
      });
      return { isValid, form: this.form };
    },
  },
  watch: {
    async isEdited(newVal) {
      if (newVal) {
        await this.fetchFilteredContractors({ serviceId: this.item.service.serviceId });
        this.fillForm();
      }
    },
    item() {
      this.fillForm();
    },
  },
};
</script>
